const IOType = {
	INPUT: 'Input',
	OUTPUT: 'Output'
};

export default IOType;
